import { Text } from '@billy/design-system'

import * as Styled from './styles'
import { getColorForId } from './utils/getColorForId'

interface AvatarPlaceholderProps {
  id?: string
  name: string
}

export const AvatarPlaceholder = ({ id, name }: AvatarPlaceholderProps) => {
  const firstTwoLetters = name.substring(0, 2)
  const backgroundColorByName = getColorForId(id)

  return (
    <Styled.AvatarPlaceholderWrapper backgroundColor={backgroundColorByName}>
      <Text weight="bold">{firstTwoLetters}</Text>
    </Styled.AvatarPlaceholderWrapper>
  )
}
